export enum ResourceRoleEnum {
  "webapp-monitor-source" = "webapp-monitor-source",
  "webapp-seller-courier" = "webapp-seller-courier",
  "webapp-sup-courier" = "webapp-sup-courier",
  "webapp-super-root" = "webapp-super-root",
  "webapp-seller-source" = "webapp-seller-source",
  "webapp-sup-seller-source" = "webapp-sup-seller-source",
  "webapp-contractor-source" = "webapp-contractor-source",
  "webapp-seller-source-bo-sstt" = "webapp-seller-source-bo-sstt",
  "webapp-super-root-no-qr" = "webapp-super-root-no-qr",
}